// extracted by mini-css-extract-plugin
export default {"EditPublicKeySection__heading":"EditPublicKeySection_EditPublicKeySection__heading__0S6xg","EditPublicKeySection__body":"EditPublicKeySection_EditPublicKeySection__body__KqJEH"};